import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../Image';

export default function BipolarPairImages({
  beforeImage,
  afterImage,
  minWidth,
}) {
  const hasBefore = beforeImage?.optimizedImageUrl || beforeImage?.imageUrl;
  const hasAfter = afterImage?.optimizedImageUrl || afterImage?.imageUrl;

  if (!hasBefore && !hasAfter) {
    return null;
  }

  return (
    <div
      className="bipolar-pair-images"
      style={minWidth ? { minWidth } : undefined}
    >
      <div className="bipolar-pair-images__item bipolar-pair-images__item--left">
        <Image row={beforeImage} />
      </div>
      <div className="bipolar-pair-images__item bipolar-pair-images__item--right">
        <Image row={afterImage} />
      </div>
    </div>
  );
}

BipolarPairImages.propTypes = {
  beforeImage: PropTypes.object,
  afterImage: PropTypes.object,
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
